"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JNTAsset = void 0;
const asset_1 = require("./asset");
/**
 * Representation of a Juneo native asset.
 */
class JNTAsset extends asset_1.TokenAsset {
    type = asset_1.TokenType.JNT;
    mintable;
    constructor(assetId, name, symbol, decimals, mintable) {
        super(assetId, name, symbol, decimals);
        this.mintable = mintable;
    }
}
exports.JNTAsset = JNTAsset;
